const GridIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.87496 1.66699V18.3337H6.50829C3.47496 18.3337 1.66663 16.5253 1.66663 13.492V6.50866C1.66663 3.47533 3.47496 1.66699 6.50829 1.66699H6.87496Z"
      fill="#3F3F46"
    />
    <path
      d="M18.3333 6.50866V9.37533H8.125V1.66699H13.4917C16.525 1.66699 18.3333 3.47533 18.3333 6.50866Z"
      fill="#3F3F46"
    />
    <path
      d="M18.3333 10.625V13.4917C18.3333 16.525 16.525 18.3333 13.4917 18.3333H8.125V10.625H18.3333Z"
      fill="#3F3F46"
    />
  </svg>
);

export default GridIcon;
